// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pager_wrap__4aNI1 {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  padding-top: 12px;
  border-top: 1px solid var(--dylo-line);
}

/*
  El rango va primero y con el número en negrita.

  📌 Es el dato que el usuario echaba de menos sin saberlo: con paginación del servidor el navegador
  solo tiene una página, así que "1–25 of 226" es la única forma de saber el tamaño real del listado.
*/
.Pager_range__A2-i2 {
  font-size: 12.5px;
  color: var(--dylo-muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}
.Pager_range__A2-i2 strong {
  color: var(--dylo-ink);
  font-weight: 600;
}

.Pager_controls__m-CpD {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  /* Empuja el selector de tamaño al extremo derecho. */
  margin-left: auto;
}

/*
  Los botones median 12px de texto sin fondo ni borde, que es lo que el usuario describió como poco
  visible. Ahora son controles de 32px con superficie y borde propios, a la altura del resto de la
  interfaz.
*/
.Pager_btn__JDsEv {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--dylo-field-border);
  background: var(--dylo-field-bg);
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease,
    transform 0.1s ease;
}
.Pager_btn__JDsEv:hover:not(:disabled) {
  /*
    ⚠️ Derivado del color del texto con \`color-mix\`, no un gris fijo. Un valor fijo es lo que hacía
    desaparecer el texto de los botones \`ghost\` en tema oscuro.
  */
  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);
  border-color: color-mix(in srgb, var(--dylo-teal-500) 45%, var(--dylo-field-border));
  color: var(--dylo-ink);
}
.Pager_btn__JDsEv:active:not(:disabled) {
  transform: scale(0.95);
}
.Pager_btn__JDsEv:disabled {
  opacity: 0.4;
  cursor: default;
}

.Pager_num__NVNi- {
  padding: 0 4px;
}

/* La página actual: sólida y con el color de marca, para que se vea de un golpe dónde estás. */
.Pager_active__udjoI,
.Pager_active__udjoI:hover:not(:disabled) {
  background: var(--dylo-teal-500);
  border-color: var(--dylo-teal-500);
  color: #fff;
}

/*
  Doble galón de "primera" y "última". Los dos iconos se solapan un poco para que se lean como un
  símbolo y no como dos flechas seguidas.
*/
.Pager_double__B07ei {
  display: inline-flex;
  align-items: center;
}
.Pager_double__B07ei > :last-child {
  margin-left: -7px;
}

/* ---- Selector de tamaño de página ---- */
.Pager_size__\\+xKoO {
  position: relative;
}
.Pager_sizeBtn__cW9WF {
  height: 32px;
  padding: 0 11px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--dylo-field-border);
  background: var(--dylo-field-bg);
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.14s ease, background 0.14s ease;
}
.Pager_sizeBtn__cW9WF:hover {
  border-color: color-mix(in srgb, var(--dylo-teal-500) 45%, var(--dylo-field-border));
  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);
}

/*
  Se abre HACIA ARRIBA: el paginador vive al final de la tabla, así que un menú hacia abajo cae fuera
  de la pantalla y obliga a desplazar — el mismo defecto que ya se corrigió en el DateTimePicker.
*/
.Pager_sizeMenu__NDAbP {
  position: absolute;
  right: 0;
  bottom: calc(100% + 6px);
  min-width: 128px;
  padding: 4px;
  border-radius: var(--radius-control);
  border: 1px solid var(--dylo-surface-border);
  background: var(--dylo-surface);
  box-shadow: var(--shadow-card);
  z-index: 30;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.Pager_sizeOption__PVRPk {
  border: none;
  background: transparent;
  color: var(--dylo-text);
  font-family: var(--font-sans);
  font-size: 12.5px;
  text-align: left;
  padding: 7px 10px;
  border-radius: var(--radius-sm);
  cursor: pointer;
}
.Pager_sizeOption__PVRPk:hover {
  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);
  color: var(--dylo-ink);
}
.Pager_sizeOptionActive__S9GuA {
  color: var(--dylo-teal-700);
  font-weight: 700;
}

@media (max-width: 640px) {
  /* En angosto el rango se lleva su propia línea y los controles quedan centrados. */
  .Pager_range__A2-i2 {
    flex: 1 1 100%;
  }
  .Pager_controls__m-CpD {
    margin-left: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .Pager_btn__JDsEv {
    transition: none;
  }
  .Pager_btn__JDsEv:active:not(:disabled) {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/v2/components/ui/Pager/Pager.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;;;;;CAKC;AACD;EACE,iBAAiB;EACjB,wBAAwB;EACxB,kCAAkC;EAClC,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,qDAAqD;EACrD,iBAAiB;AACnB;;AAEA;;;;CAIC;AACD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;EAC/B,0CAA0C;EAC1C,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf;uBACqB;AACvB;AACA;EACE;;;GAGC;EACD,+DAA+D;EAC/D,oFAAoF;EACpF,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,+FAA+F;AAC/F;;EAEE,gCAAgC;EAChC,kCAAkC;EAClC,WAAW;AACb;;AAEA;;;CAGC;AACD;EACE,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,0CAA0C;EAC1C,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,0DAA0D;AAC5D;AACA;EACE,oFAAoF;EACpF,+DAA+D;AACjE;;AAEA;;;CAGC;AACD;EACE,kBAAkB;EAClB,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,4CAA4C;EAC5C,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,YAAY;EACZ,uBAAuB;EACvB,uBAAuB;EACvB,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,eAAe;AACjB;AACA;EACE,+DAA+D;EAC/D,sBAAsB;AACxB;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,mFAAmF;EACnF;IACE,cAAc;EAChB;EACA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".wrap {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n  padding-top: 12px;\n  border-top: 1px solid var(--dylo-line);\n}\n\n/*\n  El rango va primero y con el número en negrita.\n\n  📌 Es el dato que el usuario echaba de menos sin saberlo: con paginación del servidor el navegador\n  solo tiene una página, así que \"1–25 of 226\" es la única forma de saber el tamaño real del listado.\n*/\n.range {\n  font-size: 12.5px;\n  color: var(--dylo-muted);\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n.range strong {\n  color: var(--dylo-ink);\n  font-weight: 600;\n}\n\n.controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  /* Empuja el selector de tamaño al extremo derecho. */\n  margin-left: auto;\n}\n\n/*\n  Los botones median 12px de texto sin fondo ni borde, que es lo que el usuario describió como poco\n  visible. Ahora son controles de 32px con superficie y borde propios, a la altura del resto de la\n  interfaz.\n*/\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 6px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--dylo-field-border);\n  background: var(--dylo-field-bg);\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 13px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  cursor: pointer;\n  transition: background 0.14s ease, border-color 0.14s ease, color 0.14s ease,\n    transform 0.1s ease;\n}\n.btn:hover:not(:disabled) {\n  /*\n    ⚠️ Derivado del color del texto con `color-mix`, no un gris fijo. Un valor fijo es lo que hacía\n    desaparecer el texto de los botones `ghost` en tema oscuro.\n  */\n  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);\n  border-color: color-mix(in srgb, var(--dylo-teal-500) 45%, var(--dylo-field-border));\n  color: var(--dylo-ink);\n}\n.btn:active:not(:disabled) {\n  transform: scale(0.95);\n}\n.btn:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n.num {\n  padding: 0 4px;\n}\n\n/* La página actual: sólida y con el color de marca, para que se vea de un golpe dónde estás. */\n.active,\n.active:hover:not(:disabled) {\n  background: var(--dylo-teal-500);\n  border-color: var(--dylo-teal-500);\n  color: #fff;\n}\n\n/*\n  Doble galón de \"primera\" y \"última\". Los dos iconos se solapan un poco para que se lean como un\n  símbolo y no como dos flechas seguidas.\n*/\n.double {\n  display: inline-flex;\n  align-items: center;\n}\n.double > :last-child {\n  margin-left: -7px;\n}\n\n/* ---- Selector de tamaño de página ---- */\n.size {\n  position: relative;\n}\n.sizeBtn {\n  height: 32px;\n  padding: 0 11px;\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--dylo-field-border);\n  background: var(--dylo-field-bg);\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 12.5px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: border-color 0.14s ease, background 0.14s ease;\n}\n.sizeBtn:hover {\n  border-color: color-mix(in srgb, var(--dylo-teal-500) 45%, var(--dylo-field-border));\n  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);\n}\n\n/*\n  Se abre HACIA ARRIBA: el paginador vive al final de la tabla, así que un menú hacia abajo cae fuera\n  de la pantalla y obliga a desplazar — el mismo defecto que ya se corrigió en el DateTimePicker.\n*/\n.sizeMenu {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 6px);\n  min-width: 128px;\n  padding: 4px;\n  border-radius: var(--radius-control);\n  border: 1px solid var(--dylo-surface-border);\n  background: var(--dylo-surface);\n  box-shadow: var(--shadow-card);\n  z-index: 30;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.sizeOption {\n  border: none;\n  background: transparent;\n  color: var(--dylo-text);\n  font-family: var(--font-sans);\n  font-size: 12.5px;\n  text-align: left;\n  padding: 7px 10px;\n  border-radius: var(--radius-sm);\n  cursor: pointer;\n}\n.sizeOption:hover {\n  background: color-mix(in srgb, var(--dylo-ink) 8%, transparent);\n  color: var(--dylo-ink);\n}\n.sizeOptionActive {\n  color: var(--dylo-teal-700);\n  font-weight: 700;\n}\n\n@media (max-width: 640px) {\n  /* En angosto el rango se lleva su propia línea y los controles quedan centrados. */\n  .range {\n    flex: 1 1 100%;\n  }\n  .controls {\n    margin-left: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n  .btn:active:not(:disabled) {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Pager_wrap__4aNI1`,
	"range": `Pager_range__A2-i2`,
	"controls": `Pager_controls__m-CpD`,
	"btn": `Pager_btn__JDsEv`,
	"num": `Pager_num__NVNi-`,
	"active": `Pager_active__udjoI`,
	"double": `Pager_double__B07ei`,
	"size": `Pager_size__+xKoO`,
	"sizeBtn": `Pager_sizeBtn__cW9WF`,
	"sizeMenu": `Pager_sizeMenu__NDAbP`,
	"sizeOption": `Pager_sizeOption__PVRPk`,
	"sizeOptionActive": `Pager_sizeOptionActive__S9GuA`
};
export default ___CSS_LOADER_EXPORT___;
